export default 0.1088064858095;
